import {QuerySampleItem} from './types';

export const SIMPLE_SAMPLES: QuerySampleItem[] = [
    {
        id: 'everything',
        title: 'Search for everything',
        query: '*',
        description: 'Returns all indexed records.',
    },
    {
        id: 'single-keyword',
        title: 'Simple keyword search',
        query: 'refund',
        description: 'Finds texts containing the word refund.',
    },
    {
        id: 'implicit-or',
        title: 'Default OR between words',
        query: 'refund delayed escalated',
        description: 'Matches texts containing any of the words. Use AND when all terms are required.',
    },
    {
        id: 'multi-and',
        title: 'All keywords required',
        query: 'refund AND delayed AND escalated',
        description: 'Finds texts that contain all listed keywords.',
    },
    {
        id: 'required-plus',
        title: 'Required term with +',
        query: '+refund delayed escalated',
        description: 'Requires refund; delayed and escalated are optional matches.',
    },
    {
        id: 'multi-exclude',
        title: 'Keywords with exclusion',
        query: 'refund AND delayed AND escalated -spam -test',
        description: 'Requires all positive keywords and excludes negated terms.',
    },
    {
        id: 'not-operator',
        title: 'Exclusion with NOT',
        query: 'refund NOT spam',
        description: 'Finds refund while excluding texts containing spam.',
    },
    {
        id: 'or',
        title: 'Either keyword',
        query: 'refund OR reimbursement',
        description: 'Finds texts containing at least one of the keywords.',
    },
    {
        id: 'phrase',
        title: 'Exact phrase',
        query: '"not satisfied"',
        description: 'Finds the exact phrase in order.',
    },
    {
        id: 'field-text',
        title: 'Search a specific field',
        query: 'event_text:refund',
        description: 'Limits the keyword search to the event text field.',
    },
];
